export const BACLUONG_LIST_INITING = 'BACLUONG_LIST_INITING'
export const BACLUONG_LIST_REQUESTING = 'BACLUONG_LIST_REQUESTING'
export const BACLUONG_LIST_SUCCESS = 'BACLUONG_LIST_SUCCESS'
export const BACLUONG_LIST_ERROR = 'BACLUONG_LIST_ERROR'

export const BACLUONG_DETAIL_REQUESTING = 'BACLUONG_DETAIL_REQUESTING'
export const BACLUONG_DETAIL_SUCCESS = 'BACLUONG_DETAIL_SUCCESS'
export const BACLUONG_DETAIL_ERROR = 'BACLUONG_DETAIL_ERROR'

export const BACLUONG_USER_DETAIL_REQUESTING = 'BACLUONG_USER_DETAIL_REQUESTING'
export const BACLUONG_USER_DETAIL_SUCCESS = 'BACLUONG_USER_DETAIL_SUCCESS'
export const BACLUONG_USER_DETAIL_ERROR = 'BACLUONG_USER_DETAIL_ERROR'

export const BACLUONG_UPDATE_REQUESTING = 'BACLUONG_UPDATE_REQUESTING'
export const BACLUONG_UPDATE_SUCCESS = 'BACLUONG_UPDATE_SUCCESS'
export const BACLUONG_UPDATE_ERROR = 'BACLUONG_UPDATE_ERROR'

export const BACLUONG_USER_UPDATE_REQUESTING = 'BACLUONG_USER_UPDATE_REQUESTING'
export const BACLUONG_USER_UPDATE_SUCCESS = 'BACLUONG_USER_UPDATE_SUCCESS'
export const BACLUONG_USER_UPDATE_ERROR = 'BACLUONG_USER_UPDATE_ERROR'

export const BACLUONG_USER_LIST_REQUESTING = 'BACLUONG_USER_LIST_REQUESTING'
export const BACLUONG_USER_LIST_SUCCESS = 'BACLUONG_USER_LIST_SUCCESS'
export const BACLUONG_USER_LIST_ERROR = 'BACLUONG_USER_LIST_ERROR'

export const BACLUONG_DETAIL_API = '/api/v1/bacluong/bacluong_detail_by_id'
export const BACLUONG_LIST_API = '/api/v1/bacluong/bacluong_list_by_store'
export const BACLUONG_UPDATE_API = '/api/v1/bacluong/bacluong_update_by_id'
export const BACLUONG_USER_UPDATE_API = '/api/v1/bacluong/bacluong_user_update'
export const BACLUONG_USER_DETAIL_API = '/api/v1/bacluong/getListLuongCoBan'
export const BACLUONG_USER_LIST_API = '/api/v1/bacluong/list_users_with_situation_by_store'  


// WEBPACK FOOTER //
// ./src/views/BacLuong/constants.js